import { Injectable } from '@angular/core';
import { CustomerDTO, UserDataDTO } from 'dev-corize-api-client';
import { User, UserManager } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
@Injectable({
    providedIn: 'root'
  })
export class CorizeEnvironment {
  private currentUserSubject = new BehaviorSubject<any>({});
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  public  IdentityClientId: string = "";
  public  AuthorizatioHeader: string = "";
  public  customerData: CustomerDTO;
  public  userData: UserDataDTO;
  public  IdentityEndpoint: string; 
    
  private user: User | null;

  public setUser(user:User)
  {
    this.user = user;
    this.currentUserSubject.next(user);
  }

  
  public get loggedIn() : boolean {
    return this.user != null; //TODO !!!!!! not this way verify it everywhere and keep this updated
  }
  

  getUser() :User
  {
    return this.user;
  }
}